export default function CurrencyInputbox({
  disabled = false,
  title,
  icon,
  currency,
  value,
  onChange,
}) {
  const onHandleChange = (e) => {
    const input = e.target.value;
    // Allow only numbers
    if (/^\d*\.?\d*$/.test(input)) {
      onChange(input);
    }
  };

  return (
    <div className="space-y-1">
      <p className="font-[poppins] text-xs text-[#414651] font-normal leading-[20px]">{title}</p>
      <div className="relative w-full font-[poppins] bg-[#FDFDFD] border border-[#D5D7DA] rounded-[10px] space-x-1 flex items-center">
        <div className={`absolute flex items-center pl-2.5`}>
          <div className="inline-flex items-center space-x-1">
            <img src={icon} alt="colombiaFlag" className="min-w-5 w-5 h-5" />
            <p className="text-sm font-normal leading-[20px]">{currency}</p>
            <div className="w-[1px] h-2.5 bg-[#A4A7AE]"></div>
            <span
              className={`text-sm font-normal leading-[20px] ${
                value ? 'text-[#414651]' : 'text-[#A4A7AE]'
              }`}
            >
              $
            </span>
          </div>
        </div>
        <input
          disabled={disabled}
          className="text-right pr-2 py-2 w-full text-sm font-normal leading-[20px] focus:outline-none focus:border-[#414651]"
          placeholder="0,00"
          value={value}
          onChange={onHandleChange}
        />
      </div>
    </div>
  );
}
